module.exports = __webpack_public_path__ + "media/images/home/android_icon-1b7201f2ee61dcb6b0b3e3b53f4c70b4.png";